import { render, staticRenderFns } from "./UserDashboardProducts.vue?vue&type=template&id=2e2e1723&scoped=true&"
import script from "./UserDashboardProducts.vue?vue&type=script&lang=js&"
export * from "./UserDashboardProducts.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardProducts.vue?vue&type=style&index=0&id=2e2e1723&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e1723",
  null
  
)

export default component.exports